import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import removeAccents from "remove-accents";
import { fetchServices, getServiceById } from "../../../../../../../actions/services-api";
import { useDispatch } from "react-redux";
import { SearchService } from "./searchService";
import { Box } from "./box";
import { CustomBox } from "./customBox";
import ServiceInfo from "../../../../../../../constants/models/serviceInfo";
import { ConnectionTypes, convertConnectionTypesToServiceType } from "../../../../../../../constants/utils/connectionTypes";
import { LoadingState } from "../../../../../../../_common/loadingState";

export const DefaultService = ({ selectedService, serviceDatas, isLoading, userId, displayComments, disableModifications, generateLetters }) => {
	const dispatch = useDispatch();
	const servicesRef = useRef(null);
	const [serviceOnFocus, setServiceOnFocus] = useState(undefined);
	const [searchPage, setSearchPage] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [resetPage, setResetPage] = useState(false);
	const [contractReference, setContractReference] = useState({});
	const [searchFilter, setSearchFilter] = useState([]);
	const [loadedServices, setLoadedServices] = useState([]);
	const [canFillContract, setCanFillContract] = useState(false);
	const [showCustomBox, setShowCustomBox] = useState(false);
	const [loadMore, setLoadMore] = useState(false);
	const [allBranches, setAllBranches] = useState([]);
	const [isLoadingServices, setIsLoadingServices] = useState(false);

	const [customServiceDatas, setCustomServiceDatas] = useState([]);

	const serviceType = convertConnectionTypesToServiceType(selectedService.connectionType);

	function updateLoadedItems(data) {
		if (!R.isNil(data) && data.items.length > 0) {
			let newLoadedServices = loadedServices;
			data.items.map((d) => {
				if (!loadedServices.some((l) => l.name === d.name)) {
					newLoadedServices = [...newLoadedServices, new ServiceInfo(d)];
				}
			});
			setLoadedServices(newLoadedServices);
		} else if (serviceType === "LogementProprietaire" && customServiceDatas.length === 0) {
			setShowCustomBox(true);
		}
	}

	useEffect(() => {
		if (!R.isNil(selectedService.connectionType)) {
			setContractReference({});
			setServiceOnFocus({});
			setSearchFilter([]);
			setSearchPage(0);
			setCurrentPage(1);
			setResetPage(true);
			setLoadedServices([]);
			setCanFillContract(false);
			setShowCustomBox(false);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedService]);

	useEffect(() => {
		setTimeout(() => {
			setResetPage(false);
		}, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resetPage]);

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);

		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function loadNotVisibleUserServices() {
		for (const serviceData of serviceDatas) {
			if (serviceData.serviceId.startsWith("Custom")) continue;

			if (serviceData.serviceType !== serviceType) {
				continue;
			}

			if (loadedServices.find((service) => service.branches.findIndex((b) => b.id === serviceData.serviceId) !== -1) === undefined) {
				dispatch(getServiceById(selectedService.connectionType, serviceData.serviceId)).then((response) => {
					if (Array.isArray(response) === false) {
						response = { items: [response] };
					}
					//setLoadedServices(response.map(e => new ServiceInfo(e)));
					updateLoadedItems(response);
				});
			}
		}
	}

	useEffect(() => {
		if (!isLoadingServices && loadedServices.length > 0) {
			loadNotVisibleUserServices();
		}
	}, [isLoadingServices]);

	useEffect(() => {
		if (canFillContract === true) {
			let tmpContracts = {};
			if (!R.isEmpty(serviceDatas)) {
				serviceDatas.forEach((serviceData) => {
					tmpContracts[serviceData.serviceId] = serviceData.payload.reference;
				});
			}
			setContractReference(tmpContracts);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [canFillContract, serviceDatas]);

	const handleClickOutside = (event) => {
		if (servicesRef.current && !servicesRef.current.contains(event.target)) {
			setServiceOnFocus(undefined);
			setSearchPage(0);
		}
	};
	if (canFillContract === false && !R.isEmpty(serviceDatas)) {
		setCanFillContract(true);
	}

	useEffect(() => {
		if (!R.isNil(loadedServices)) {
			const branchAggregations = [];
			R.sortWith([R.ascend(R.prop("nameNoAccents"))])(loadedServices)
				.filter((s) => s.branches.length !== 0)
				.forEach((s) => {
					s.branches.forEach((branch) => {
						let a = R.isNil(branch.name) ? "" : branch.name.toLowerCase();
						let b = selectedService.connectionType !== ConnectionTypes.waterSupplier ? (R.isNil(branch.address.addressLocality) ? "" : (!R.isNil(branch.address.postalCode) ? branch.address.postalCode + " " : "") + branch.address.addressLocality.toLowerCase()) : R.isNil(s.name) ? "" : s.name.toLowerCase();
						let c = R.isNil(branch.address.streetAddress) ? "" : branch.address.streetAddress.toLowerCase();
						let normalizedNameAndAddress = removeAccents(a).replace(/\s/gi, "") + "(" + removeAccents(b).replace(/\s/gi, "") + ")" + removeAccents(c).replace(/\s/gi, "");
						let hide = searchFilter.length > 0 ? true : false;
						searchFilter.length > 0 &&
							searchFilter.forEach((f) => {
								if (normalizedNameAndAddress.includes(removeAccents(f.value.toLowerCase()).replace(/\s/gi, "")) && (!R.isNil(f.address) ? normalizedNameAndAddress.includes(removeAccents(f.address.toLowerCase()).replace(/\s/gi, "")) : true)) {
									hide = false;
								}
							});
						if (hide !== true) {
							const inputOnFocus = branch.id === serviceOnFocus;
							const withServiceData = serviceDatas.some((s) => s.serviceId === branch.id);
							//let withServiceData = (!R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].findIndex(s => s.serviceId === branch.id) !== -1);
							let isCollapsed = !(inputOnFocus || (!R.isNil(contractReference[branch.id]) && (selectedService.connectionType === ConnectionTypes.insurance ? contractReference[branch.id].length > 0 : contractReference[branch.id] !== ""))) && !withServiceData;
							branchAggregations.push({ isCollapsed: isCollapsed, branch: branch, inputOnFocus: inputOnFocus, withServiceData: withServiceData });
							//setAllBranches([...allBranches, { isCollapsed: isCollapsed, branch: branch, inputOnFocus: inputOnFocus, withServiceData: withServiceData }])
						}
					});
				});
			const sortedBranches = R.sortWith([R.descend(R.prop("withServiceData"))])(branchAggregations);
			setAllBranches(sortedBranches);
		}

		setCustomServiceDatas(serviceDatas.filter((s) => s.serviceType === serviceType && !R.isNil(s.serviceId) && s.serviceId !== "" && s.serviceId.toLowerCase().startsWith("custom")));
	}, [serviceDatas, selectedService, loadedServices, serviceOnFocus, searchFilter]);

	return (
		<article className="block" id={selectedService.title}>
			<h3 className="sr-only visually-hidden">{selectedService.title}</h3>
			<section className="card card-body">
				<div className="block">
					{selectedService.title ? (
						<div className={"grid-sm grid-sm-1 grid-md-3 gx-1 align-items-center" + (!R.isNil(loadedServices) ? " mb-0" : " mb-sm")}>
							<div className="block my-auto">
								<h5 className="h4 text-uppercase text-secondary font-weight-black mt-auto mb-0">{selectedService.title}</h5>
								<p className="mb-auto fs-3 o-80">{selectedService.detailedDescription}</p>
							</div>
							<div className="ml-md-auto grid-column-md-2">
								<button
									type="button"
									className="btn p-0 align-middle text-gray no-outline text-md-right"
									onClick={(e) => {
										e.preventDefault();
										setShowCustomBox(true);
									}}>
									Cliquez ici si vous ne trouvez pas votre <span className="text-uppercase">{selectedService.title}</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
								</button>
							</div>
						</div>
					) : (
						""
					)}
					{!R.isNil(loadedServices) ? (
						<div className="form-group mb-0 py-3 bg-white sticky-top">
							{resetPage ? (
								""
							) : (
								<SearchService
									connectionType={selectedService.connectionType}
									searchPage={searchPage}
									setSearchPage={setSearchPage}
									searchFilter={searchFilter}
									setSearchFilter={setSearchFilter}
									setCurrentPage={setCurrentPage}
									updateLoadedItems={updateLoadedItems}
									setLoadMore={setLoadMore}
									setIsLoadingServices={setIsLoadingServices}
									isLoadingServices={isLoadingServices}
								/>
							)}
						</div>
					) : (
						""
					)}
					{showCustomBox ? (
						<CustomBox
							key={"custom"}
							boxIndex={"custom"}
							connectionType={selectedService.connectionType}
							customServiceData={null}
							setServiceOnFocus={setServiceOnFocus}
							inputOnFocus={null}
							setShowCustomBox={setShowCustomBox}
							setSearchFilter={setSearchFilter}
							isLoading={isLoading}
							serviceDatas={serviceDatas}
							userId={userId}
							displayComments={displayComments}
							disableModifications={disableModifications}
							generateLetters={generateLetters}
						/>
					) : (
						""
					)}
					<p className="fs-3 text-gray">Sélectionner un ou plusieurs organismes en cliquant sur les éléments ci-dessous.</p>
					{loadedServices.length === 0 && serviceType !== "LogementProprietaire" ? <LoadingState /> : ""}
					<div className={"grid-sm grid-md-min grid-lg-tight grid-lg-4 mt-3"} ref={servicesRef}>
						{R.isNil(customServiceDatas)
							? ""
							: customServiceDatas.map((customServiceData, index) => {
									if (R.isNil(customServiceData.customServiceDetails)) {
										return "";
									}
									return (
										<CustomBox
											key={"custom" + index}
											boxIndex={"custom" + index}
											connectionType={selectedService.connectionType}
											customServiceData={customServiceData}
											setServiceOnFocus={setServiceOnFocus}
											inputOnFocus={null}
											setShowCustomBox={setShowCustomBox}
											isActive={true}
											setSearchFilter={setSearchFilter}
											userId={userId}
											isLoading={isLoading}
											serviceDatas={serviceDatas}
											displayComments={displayComments}
											disableModifications={disableModifications}
											generateLetters={generateLetters}
										/>
									);
							  })}

						{allBranches.map((b, index) => {
							let isCollapsed = b.isCollapsed;
							if (allBranches.length === 1) {
								isCollapsed = false;
							}
							return (
								<Box
									key={index + b.branch.id}
									boxIndex={b.branch.id}
									connectionType={selectedService.connectionType}
									isCollapsed={isCollapsed}
									setServiceOnFocus={setServiceOnFocus}
									branch={b.branch}
									contractReference={contractReference}
									setContractReference={setContractReference}
									inputOnFocus={b.inputOnFocus}
									setSearchFilter={setSearchFilter}
									isLoading={isLoading}
									userId={userId}
									serviceDatas={serviceDatas}
									displayComments={displayComments}
									disableModifications={disableModifications}
									generateLetters={generateLetters}
								/>
							);
						})}
					</div>
					{loadMore ? (
						<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-white pt-3 pb-2">
							<h4 className="sr-only visually-hidden">Plus</h4>
							<button
								onClick={async () => {
									let response = await dispatch(fetchServices(selectedService.connectionType, currentPage));
									if (response.items.length < 100) {
										setLoadMore(false);
									} else {
										setLoadMore(true);
									}
									updateLoadedItems(response);
									setCurrentPage(currentPage + 1);
								}}
								type="button"
								className="btn btn-icon btn-alert-light mx-auto py-2">
								<i className="eva eva-more-horizontal-outline h3 my-auto mr-2"></i>Plus
							</button>
						</footer>
					) : (
						""
					)}
				</div>
			</section>
		</article>
	);
};
